<template>
    <ui-modal id="delete-comment" title="Confirmar Exclusão" title-text="Tem certeza que deseja excluir seu comentário?" size="xs">
        <div class="control">
            <button type="button" class="btn-cancel" @click="modal('modal-close', 'delete-comment')">Cancelar</button>
            <button type="button" class="btn-confirm" @click="removeConfirm()">Confirmar</button>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components'
    import { conversations } from '@/services'
    export default {
        components: { uiModal },
        props: {
            comment: {}
        },
        watch:{
            comment: function(comment){
                return comment
            }
        },
        methods: {
            modal(action, id){
                this.$root.$emit(action, id);
            },
            removeConfirm(){
                conversations.remove(this.comment).then( () => {
                    this.$root.$emit('remove-comment-item', this.comment.index);
                })
            }, 
        },
        created(){
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
